module.exports = __webpack_public_path__ + "static/media/logo.8fd048a3.png";